import { SplitTest } from 'Shared/services/opa/api/opaApi';
import { getActiveDecisionVariables, getSplitTestConfigs } from 'Shared/services/opa/app/splitTestService';
import { OPA_FLAG, OPA_VARIABLE } from 'Shared/services/opa/constants';

export interface PromoBannerSplitTest extends SplitTest {
  variables: {
    [OPA_VARIABLE.SPA_SJGROW_3366_ENABLED]: boolean | null,
  }
}

/**
 * Returns the split test configuration for promo banner
 */
export const promoBannerSplitTest = (): PromoBannerSplitTest => {
  const testDecision = getSplitTestConfigs([OPA_FLAG.SPA_PROMO_SJGROW_3366]);
  const variables    = getActiveDecisionVariables(OPA_FLAG.SPA_PROMO_SJGROW_3366, testDecision);

  return {
    enabled: !!variables,
    variables: {
      [OPA_VARIABLE.SPA_SJGROW_3366_ENABLED]: variables?.[OPA_VARIABLE.SPA_SJGROW_3366_ENABLED],
    }
  };
};

